import { Field, ErrorMessage, FieldInputProps } from "formik";
import { useTranslation } from "react-i18next";
import InputWithIcon from "@/components/input/input";
import MaskedInput from "@/components/input/inputMask";
import { ErrorText, MarginBottom } from "@/screens/login/login-seller/style";
import { TitleInput } from "@/screens/register/register-buy/style";
import { FaRegAddressCard } from "react-icons/fa6";
import { FaWpforms } from "react-icons/fa";
import { CiPhone } from "react-icons/ci";
import { MdCorporateFare, MdOutlineEmail } from "react-icons/md";

interface Props {
  selectedOption: number;
  registerError: any;
}

const StepBuyerBasicInfo: React.FC<Props> = ({
  selectedOption,
  registerError,
}: Props) => {
  const { t } = useTranslation();

  return (
    <>
      <TitleInput> {t("name")}</TitleInput>
      <Field name="business_name">
        {({ field }: { field?: FieldInputProps<any> }) => (
          <InputWithIcon
            icon={<FaWpforms />}
            iconSize="23px"
            field={field}
            placeholder={t("type-name")}
          />
        )}
      </Field>
      <ErrorText>
        <ErrorMessage name="business_name" />
      </ErrorText>
      <MarginBottom />

      {selectedOption === 1 && (
        <>
          <TitleInput>CPF</TitleInput>
          <Field name="document">
            {({ field }: { field?: FieldInputProps<any> }) => (
              <MaskedInput
                field={field}
                icon={<FaRegAddressCard />}
                mask="999.999.999-99"
                iconSize="23px"
                placeholder={t("type-document")}
              />
            )}
          </Field>
          <ErrorText>
            <ErrorMessage name="document" />
          </ErrorText>
          <MarginBottom />
        </>
      )}

      <TitleInput> {t("phone")}</TitleInput>
      <Field name="phone">
        {({ field }: { field?: FieldInputProps<any> }) => (
          <MaskedInput
            field={field}
            icon={<CiPhone />}
            mask="(99) 99999-9999"
            iconSize="23px"
            placeholder={t("type-phone")}
          />
        )}
      </Field>
      <ErrorText>
        <ErrorMessage name="phone" />
      </ErrorText>

      <MarginBottom />

      <TitleInput>{t("email")}</TitleInput>
      <Field
        type="text"
        name="email"
        render={({ field }: { field?: FieldInputProps<any> }) => (
          <InputWithIcon
            icon={<MdOutlineEmail />}
            iconSize="23px"
            field={field}
            placeholder="Digite seu Email."
          />
        )}
      />

      {registerError.some((error: any) => error.field === "email") ? (
        // Se houver um erro específico, exiba apenas o erro personalizado
        registerError
          .filter((error: any) => error.field === "email")
          .map((error: any, index: any) => (
            <ErrorText key={index}>
              <p>{error.msgs}</p>
            </ErrorText>
          ))
      ) : (
        // Caso contrário, exiba o erro do Formik
        <ErrorText>
          <ErrorMessage name="email" />
        </ErrorText>
      )}

      <MarginBottom />

      {selectedOption === 2 && (
        <>
          <TitleInput>CNPJ</TitleInput>
          <Field name="cnpj">
            {({ field }: { field?: FieldInputProps<any> }) => (
              <MaskedInput
                field={field}
                icon={<FaRegAddressCard />}
                mask="99.999.999/9999-99"
                iconSize="23px"
                placeholder={t("type-cnpj")}
              />
            )}
          </Field>
          <ErrorText>
            <ErrorMessage name="cnpj" />
          </ErrorText>
          <MarginBottom />

          <TitleInput> {t("corporate-reason")}</TitleInput>
          <Field name="corporate_name">
            {({ field }: { field?: FieldInputProps<any> }) => (
              <InputWithIcon
                icon={<MdCorporateFare />}
                iconSize="23px"
                field={field}
                placeholder={t("type-company-name")}
              />
            )}
          </Field>
          <ErrorText>
            <ErrorMessage name="corporate_name" />
          </ErrorText>
          <MarginBottom />

          <TitleInput> {t("state-registration")}</TitleInput>
          <Field name="state_registration">
            {({ field }: { field?: FieldInputProps<any> }) => (
              <InputWithIcon
                icon={<MdCorporateFare />}
                iconSize="23px"
                field={field}
                placeholder={t("type-state-registration")}
              />
            )}
          </Field>
          <ErrorText>
            <ErrorMessage name="state_registration" />
          </ErrorText>
          <MarginBottom />
        </>
      )}
    </>
  );
};

export default StepBuyerBasicInfo;
